module.exports = __webpack_public_path__ + "media/assets/fonts/NeueHaasGrotesk-Light-46f0c2f76453ff7dcfba3186e64c8d23.ttf";